import Authorization from './Authorization.js'

export default class AuthorizationFilter {

  constructor() {
    this.roles = {
      admin: window.hasRole(Authorization.ROLES.admin),
      user: window.hasRole(Authorization.ROLES.user)
    }
  }

  viewAllowed(name) { // NOSONAR complexity: too many returns
    if (this._isAnonymousForm(name)) {
      return true
    }

    switch (name) {
      case '':
      case 'Landing':
      case 'wbf-bwo-fdr':
      case 'wbf-bwo-statutenpruefung':
      case 'wbf-bwo-forschungsgesuch':
      case 'wbf-seco-beschwerdeformular':
      case 'wbf-seco-sas-beschwerdeformular':
      case 'wbf-isceco-testformular':
      case 'Monitoring':
      case 'wbf-sbfi-gesuchformular':
      case 'wbf-sbfi-gesuchformular-gesuch':
      case 'wbf-sbfi-gesuchformular-reporting':
      case 'wbf-sbfi-projektfinanzierungsgesuch':
      case 'wbf-nachtrag':
        return this._hasAnyRole()
      case 'Dashboard':
      case 'Administration':
      case 'AdministrationEdit':
        return this.roles.admin
      default:
        return false
    }
  }

  _isAnonymousForm(name) {
    if (window.isAnonymousAccess && window.eformConfig && window.eformConfig.anonymousForms) {
      return window.eformConfig.anonymousForms.includes(name)
    }
    return false
  }

  _hasAnyRole() {
    return Object.values(this.roles).find(value => value === true) || false
  }

}
